<!-- @format -->

<div
	#compareBarContainer
	class="plp-srlp-compare-bar hmf-display-flex hmf-justify-content-between hmf-px-s hmf-px-l-m hmf-py-xs hmf-span-12">
	<p class="compare-selected-count hmf-align-self-center hmf-body-l hmf-my-0">
		{{ compareList().length }}
		<span class="hmf-display-none hmf-display-lg-inline">
			Product{{ compareList().length === 1 ? ' ' : 's ' }}</span
		>Selected
	</p>

	<div class="compare-actions-container hmf-display-flex hmf-justify-content-flex-end">
		@if (showThumbnails()) {
			@for (compareProduct of compareList(); track compareProduct.ecode) {
				<plp-components-compare-thumbnail
					class="hmf-px-xxs"
					[compareData]="compareProduct"
					(remove)="
						removeFromCompareList($event, $index)
					"></plp-components-compare-thumbnail>
			}
		}
		<button
			hmf-button
			class="compare-action-button-clear hmf-align-self-center hmf-mr-xxxs hmf-ml-s"
			label="Remove all products from Comparison Bar"
			[variant]="'secondary'"
			[size]="actionButtonsSize()"
			(click)="clearAllCompareList()">
			Clear All
		</button>
		<button
			hmf-button
			class="compare-action-button-compare hmf-align-self-center hmf-mx-xxxs"
			label="Open Product Comparison Panel"
			[variant]="'primary'"
			[size]="actionButtonsSize()"
			[disabled]="compareList().length < 2"
			(click)="compareProducts()"
			(keydown.tab)="tabPressed.emit()">
			Compare
		</button>
	</div>
</div>
